import objectFitImages from 'object-fit-images';

$(window).on("load resize orientationchange", function () {

    $(function () { objectFitImages() });

});